"use strict";
/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Footer_1 = require("decentraland-ui/dist/components/Footer/Footer");
const Navbar_1 = require("decentraland-ui/dist/components/Navbar/Navbar");
const useAuthContext_1 = __importDefault(require("../../context/Auth/useAuthContext"));
const utils_1 = require("../../context/Auth/utils");
const FeatureFlag_1 = require("../../context/FeatureFlag");
const types_1 = require("../../context/FeatureFlag/types");
const useShareContext_1 = __importDefault(require("../../context/Share/useShareContext"));
const useTrackLinkContext_1 = __importDefault(require("../../context/Track/useTrackLinkContext"));
const useWindowScroll_1 = __importDefault(require("../../hooks/useWindowScroll"));
const utils_2 = require("../../plugins/intl/utils");
const TokenList_1 = __importDefault(require("../../utils/dom/TokenList"));
const trackEvent_1 = __importDefault(require("../../utils/segment/trackEvent"));
const ShareModal_1 = __importDefault(require("../Modal/ShareModal"));
const WalletSelectorModal_1 = __importDefault(require("../Modal/WalletSelectorModal"));
const WrongNetworkModal_1 = __importDefault(require("../Modal/WrongNetworkModal"));
require("./Layout.css");
function Layout(_a) {
    var _b, _c;
    var { children, pageContext, availableProviders, hideNavbar, hideFooter } = _a, props = __rest(_a, ["children", "pageContext", "availableProviders", "hideNavbar", "hideFooter"]);
    const locale = ((_b = pageContext === null || pageContext === void 0 ? void 0 : pageContext.intl) === null || _b === void 0 ? void 0 : _b.locale) || 'en';
    const locales = ((_c = pageContext === null || pageContext === void 0 ? void 0 : pageContext.intl) === null || _c === void 0 ? void 0 : _c.locales) || ['en'];
    const [, state] = (0, useAuthContext_1.default)();
    const [, shareState] = (0, useShareContext_1.default)();
    const [ff] = (0, FeatureFlag_1.useFeatureFlagContext)();
    const scroll = (0, useWindowScroll_1.default)() || null;
    const isScrolled = scroll.scrollY.get() > 0;
    const handleChangeLocal = function (_, data) {
        (0, utils_2.changeLocale)(data.value);
    };
    const handleClickMenuOption = (0, useTrackLinkContext_1.default)(function (event, section) {
        if (props.onClickMenuOption) {
            props.onClickMenuOption(event, section);
        }
        if (!event.defaultPrevented) {
            return {
                place: 'navbar',
                section,
                menu: section.split('_'),
            };
        }
        return null;
    }, [props.onClickMenuOption]);
    const handleSwitchNetwork = (0, react_1.useCallback)((chainId) => state.switchTo(chainId), [state]);
    const handleConnect = (0, react_1.useCallback)((providerType, chainId) => state.connect(providerType, chainId), [state]);
    const handleCancelConnect = (0, react_1.useCallback)(() => state.select(false), [state]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !hideNavbar && (react_1.default.createElement(Navbar_1.Navbar, { mana: props.mana, address: props.address, activePage: props.activePage, leftMenu: props.leftMenu, middleMenu: props.middleMenu, rightMenu: props.rightMenu, i18n: props.i18n, isConnected: props.isConnected, isConnecting: props.isConnecting, isSignIn: props.isSignIn, isFullscreen: props.isFullscreen, isOverlay: props.isOverlay, className: TokenList_1.default.join([
                // TODO(#323): remove on v6 use bem notation
                'LayoutNavbarContainer',
                'layout__navbar',
                props.className,
                !isScrolled && 'initial',
            ]), onSignIn: props.onSignIn, onClickAccount: props.onClickAccount, onClickMenuOption: handleClickMenuOption })),
        react_1.default.createElement("main", { className: TokenList_1.default.join([
                // TODO(#323): remove on v6 use bem notation
                'LayoutMainContainer',
                'layout__main',
                props.className,
            ]) }, children),
        react_1.default.createElement(ShareModal_1.default, { data: shareState.data, onClose: shareState.close }),
        react_1.default.createElement(WrongNetworkModal_1.default, { currentNetwork: state.chainId, expectedNetwork: (0, utils_1.getSupportedChainIds)(), onSwitchNetwork: handleSwitchNetwork, providerType: state.providerType }),
        react_1.default.createElement(WalletSelectorModal_1.default, { open: state.selecting, loading: state.loading, error: state.error, onConnect: handleConnect, availableProviders: availableProviders, disabledWalletConnect2: !ff.enabled(types_1.DappsFeatureFlags.WalletConnectV2), onClose: handleCancelConnect }),
        !hideFooter && (react_1.default.createElement(Footer_1.Footer, { locale: locale, locales: locales, isFullscreen: props.isFullscreen, className: TokenList_1.default.join([
                // TODO(#323): remove on v6 use bem notation
                'LayoutFooterContainer',
                'layout__footer',
                props.className,
            ]), i18n: props.i18n, onChange: (0, trackEvent_1.default)(handleChangeLocal) }))));
}
exports.default = Layout;
